<template>
  <v-card class="elevation-0">
    <v-checkbox
      :data-cy="`${dropdownAttributeName}-deprecated-checkbox`"
      :id="`${dropdownAttributeName}-deprecated-checkbox`"
      :label="`Show deprecated values (${deprecatedCount})`"
      class="deprecated-checkbox mt-4 my-n4"
      dense
      v-model="includeDeprecated"
    ></v-checkbox>
    <v-autocomplete
      :data-cy="`${dropdownAttributeName}-selector`"
      :id="`${dropdownAttributeName}-selector`"
      :items="filteredList"
      :item-text="displayText"
      :label="dropdownLabel"
      :rules="rules"
      dense
      filled
      item-value="id"
      v-model="selectedValue"
      :hint="hintText"
      :persistent-hint="!!hintText"
    >
      <template v-slot:item="{ item }">
        <span :class="{ 'grey--text text--darken-1 font-italic': item.isDeprecated }">
          {{ item.label }}
          <span v-if="item.isDeprecated" class="deprecated-label"> (DEPRECATED)</span>
        </span>
      </template>
    </v-autocomplete>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    dropdown() {
      return this.dropdownList.find(dropdown => dropdown.attributeName === this.dropdownAttributeName);
    },
    dropdownLabel() {
      if (this.required) {
        return `${this.dropdown.label} *`;
      }
      return this.dropdown.label;
    },
    filteredList() {
      let filteredList = this.dropdown.valueList;

      if (this.grouperValue) {
        filteredList = this.filterListByGrouper(filteredList);
      }

      filteredList = filteredList.filter(({ id, isDeprecated }) => {
        // If the selected value is a deprecated value but we are excluding deprecated values from the list,
        // the selected deprecated value should be included in the filtered list so it can be seen.
        return this.includeDeprecated ? true : !isDeprecated || id === this.selectedValue;
      });

      // Separate active and deprecated values
      const active = filteredList.filter(item => !item.isDeprecated);
      const deprecated = filteredList.filter(item => item.isDeprecated);

      // Sort each group alphabetically by label
      const sortByLabel = (a, b) => a.label.localeCompare(b.label);

      return [...active.sort(sortByLabel), ...deprecated.sort(sortByLabel)];
    },
    deprecatedCount() {
      let valueList = this.dropdown.valueList;

      if (this.grouperValue) {
        valueList = this.filterListByGrouper(valueList);
      }

      return valueList.filter(item => item.isDeprecated).length;
    },
    hintText() {
      if (!this.includeDeprecated || this.deprecatedCount === 0) {
        return "";
      }

      return "Deprecated values appear at the bottom of the list";
    },
  },
  data() {
    return {
      includeDeprecated: null,
      rules: [this.fieldIsRequired()],
      selectedValue: null,
    };
  },
  created() {
    this.selectedValue = this.value;
  },
  methods: {
    displayText(item) {
      if (item) {
        const deprecatedText = item.isDeprecated ? " (DEPRECATED)" : "";
        return `${item.label}${deprecatedText}`;
      }
    },
    fieldIsRequired() {
      if (this.required) {
        return v => !!v || "Field is required";
      }
      return true;
    },
    filterListByGrouper(filteredList) {
      return filteredList.filter(val => {
        return val.groupDropdownValueId === this.grouperValue;
      });
    },
  },
  props: {
    dropdownList: { required: true, type: Array },
    dropdownAttributeName: { required: true, type: String },
    grouperValue: { type: Number },
    required: { type: Boolean, default: false },
    value: { type: [Number] },
  },
  watch: {
    selectedValue(val) {
      this.$emit("selectValue", val);
    },
    value(val) {
      this.selectedValue = val;
    },
  },
};
</script>

<style scoped>
::v-deep .deprecated-checkbox .v-label {
  font-size: 0.85rem;
}

.deprecated-label {
  font-size: 0.85em;
  color: grey;
  font-weight: normal;
}
</style>
